import { Badge } from "react-bootstrap";

export default function CoverStatusBadge ({ cover, coverValue }) {

    const coverStatusBadge = {
        "required": <Badge bg="danger">Obligatoire</Badge>,
        "included": <Badge bg="success">Inclus</Badge>,
        "not_included": <Badge bg="danger">Non inclus</Badge>,
        "optional_on": <Badge bg="warning">Optionnel (o)</Badge>,
        "optional_off": <Badge bg="info">Optionnel (n)</Badge>,
        "forbidden": <Badge bg="secondary">Interdit</Badge>,
        "hidden": <Badge bg="secondary">Caché</Badge>,
        "automatic_on": <Badge bg="success">Auto: inclus</Badge>,
        "automatic_off": <Badge bg="danger">Auto: non inclus</Badge>,
        "default": <Badge>(?) {cover?.state ?? "Inconnu"}</Badge>,
    };

    // if cover state is automatic, we need to check the cover value

    if (cover?.state === "automatic") {
        if (typeof coverValue?.status === "boolean" && coverValue?.status === true ||
            typeof coverValue?.status === "number" && coverValue?.status === 1 ||
            typeof coverValue?.status === "string" && coverValue?.status === "1" ||
            typeof coverValue?.status === "string" && coverValue?.status === "true") { 
            return coverStatusBadge["automatic_on"];
        } else {
            return coverStatusBadge["automatic_off"];
        }
    }

    return <>
        {coverStatusBadge[cover?.state] || coverStatusBadge["default"]}
    </>

}